
<template>
  <div class="d-flex">
    <div class="content-fixed" v-if="data.detailsText.title || data.detailsText.warn">
      <p class="content-title">{{data.detailsText.title}}</p>

      <div>
        <p class="content-warn">{{data.detailsText.warn}}</p>
        <!-- <p class="content-content">{{data.detailsText.content}}</p> -->
        <!-- <div class="content-icon" alt="下划线" /> -->
      </div>
    </div>

    <div class="content-scroll">
      <div class="content-scroll-wrapper" v-for="item in data.detailsText.illustrate" :key="item.id">
        <p class="content-scroll-illustrate" v-html="item.illustrateContent"></p>
      </div>
      <div class="content-img-wrapper" v-if="data.detailsText.img">
        <img class="content-img" :src="data.detailsText.img" alt="二维码" />
        <p class="content-warn">{{data.detailsText.detailsTextWarn}}</p>
      </div>
      <div class="content-img-wrapper" v-if="data.detailsText.imgsList" v-for="(item, index) in data.detailsText.imgsList" :key="index">
        <img class="content-img" :src="item.logo" alt="二维码" />
        <p class="content-warn">{{item.text}}</p>
      </div>
      <div class="content-img-wrapper" v-if="data.detailsText.imgUrl">
        <img class="content-img-top" :src="data.detailsText.imgUrl" alt="赛事结果" />
      </div>
      <p class="content-warn">{{data.detailsText.illustrateWarn}}</p>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['data']
}
</script>

<style lang="scss" scoped>
.d-flex{
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content-title {
  position: relative;
  margin: 0 auto 34px;
  line-height: 38px;
  font-size: 22px; font-weight: 500;
  color: #000000;
  font-family: Alibaba-PuHuiTi-Heavy;

  &::after {
    content: " ";
    position: absolute; top: 43px; left: 50%; right: -20px;
    width: 40px; height: 5px;
    background: #DE3640;
    transform: translateX(-50%);
  }

  @include mobile {
    font-size: 16px;
    line-height: 22px;
  }
}

.content-warn {
  margin-bottom: 20px;
  color: #828A92;
  line-height: 20px;
  font-size: 14px; font-weight: 400;

  @include mobile {
    font-size: 12px;
  }
}

.content-content {
  margin-bottom: 20px;
  color: #000000;
  line-height: 28px;
  text-align: left;
  font-size: 16px; font-weight: 500;

  @include mobile {
    font-size: 12px;
    line-height: 1.5;
  }
}

.content-icon {
  width: 100%; height: 2px;
  margin: 0 auto 20px;
  background: url('~@/assets/transSave/resource/image/d3/99/d326ce14aa4e3a59f741a60300d2af99.png') center / cover no-repeat;
}

.content-scroll {
  height: auto;
  text-align: left;
  overflow-y: visible;
  min-height: 350px;

  @include mobile {
    max-height: none;
    min-height: 250px;
  }
}

.content-scroll-wrapper {
  margin-bottom: 20px;
}

.content-scroll-illustrate {
  color: #000000;
  line-height: 35px;
  font-size: 16px; font-weight: 400;

  @include mobile {
    font-size: 12px;
    line-height: 1.5;
  }
}

.content-img-wrapper {
  display: flex; flex-direction: column; justify-content: center; align-items: center;
}

.content-img {
  width: 150px; height: 150px;
}

.content-img-top {
  width: 100%;
}

.content-scroll-warn {
  color: #828A92;
  line-height: 28px;
  text-align: center;
  font-size: 14px; font-weight: 400;

  @include mobile {
    font-size: 12px;
    line-height: 20px;
  }
}

// 默认出现滚动条
.content-scroll::-webkit-scrollbar {
 -webkit-appearance: none;
 }

 .content-scroll::-webkit-scrollbar:vertical {
   width: 7px;
 }

 .content-scroll::-webkit-scrollbar:horizontal {
   height: 0.06rem;
 }

.content-scroll::-webkit-scrollbar-thumb {
  // border: 2px solid white; /* should match background, can't be transparent */
  background-color: #d8d8d8;
  border-radius: 5px;
}

</style>
